import YouTube from "react-youtube";

export const Home = () => {
  return (
    <div>
      <div>
        <YouTube
          videoId={"ESwVijz7L-o"}
          opts={{
            width: "100%",
            height: "600",
            playerVars: {
              autoplay: 1,
              rel: 0,
              modestbranding: 1,
              mute: 1,
              loop: 1,
            },
          }}
          //이벤트 리스너
          onEnd={(e: any) => {
            e.target.stopVideo(0);
          }}
        />
      </div>
    </div>
  );
};
